// extracted by mini-css-extract-plugin
export default {"button":"CartBtn_button__-Ks7Z","icon":"CartBtn_icon__2O9TK","badge":"CartBtn_badge__+zsS4","bump":"CartBtn_bump__LLg8h"};